/**
 * FAQ accordions inside editorial-text sections.
 *
 * - Gives each accordion group's <details> rows a shared `name`, so the
 *   browser natively keeps at most one row open per group.
 * - Reserves the group's tallest open-state height as min-block-size, so
 *   opening a row never changes the section height or reflows the page
 *   below it.
 *
 * Measurement toggles rows within a single task, so nothing paints
 * mid-measure. Rows open instantly (transitions are disabled in
 * editorial-text.liquid), which keeps offsetHeight accurate.
 */

/**
 * Reserves space for the tallest open row of an accordion group.
 * @param {HTMLElement} accordion
 * @param {number} index - Page-unique group index for the exclusivity name
 */
function reserve(accordion, index) {
  const rows = [...accordion.querySelectorAll('details')];
  if (rows.length === 0) return;

  for (const row of rows) row.setAttribute('name', `be-faq-${index}`);

  // Temporarily disabled: reserved-height measurement (min-block-size)
  // const openRow = rows.find((row) => row.open);
  accordion.style.minBlockSize = '';

  // let max = accordion.offsetHeight;
  // for (const row of rows) {
  //   // The shared `name` closes the previous row as each one opens
  //   row.open = true;
  //   max = Math.max(max, accordion.offsetHeight);
  // }
  // for (const row of rows) row.open = row === openRow;
  //
  // accordion.style.minBlockSize = `${Math.ceil(max)}px`;
}

function update() {
  document.querySelectorAll('.be-editorial-text__items > .accordion').forEach(reserve);
}

let resizeTimeout = 0;
function onResize() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(update, 150);
}

update();
document.fonts.ready.then(update);
window.addEventListener('resize', onResize);
document.addEventListener('shopify:section:load', update);
